import react, { Component } from 'react';
import { DKIcon, DKRadioButton, DKLabel,Toggle, DKInput, DKCheckMark,INPUT_VIEW_DIRECTION, DKButton, DKLine, showToast, TOAST_TYPE } from "deskera-ui-library";
import {
  COLUMN_CODES,
  EPF_EMPLOYER_CONTRIBUTION,
  EPF_RESTRICT_TO_CEILING,
  EPF_RESTRICT_TO_CEILING_LEGACY,
  EPF_NUMBER_MASK,
  ESI_NUMBER_MASK,
  INPUT_TYPE,
  PROFILE_STAGES_CONSTANT,
  IN_STATES_WITH_CONFIGURATION,
  IN_TAX_REGIME_OPTIONS,
} from "../../../../constants/Constant";
import { EPF_REGEX_PATTERN, ESI_REGEX_PATTERN, NUMBER_REGEX_PATTERN, PAN_REGEX_PATTERN } from '../../../../constants/RegexConstants';
import ic_info_warning from "../../../../assets/icons/ic_info_gray.svg";
import ReactTooltip from 'react-tooltip';
import INTaxService from '../../../../services/compliance/IN/IntaxSerivce';
import RouteManager from '../../../../managers/RouteManager';
import ProfileSetupService from '../../../../services/ProfileSetup-service';
import TenantManager from '../../../../managers/TenantManager';
import Utility from '../../../../utility/Utility';

import PermissionUtils, { ACTION, MODULE } from '../../../user-permissions/PermissionUtils';
class TaxDetails extends Component<any, any> {
    metaData = {};
    taxDeatils = {

        compliance: {
          "@type": "type.googleapis.com/v1.INTaxDetails",
          "epefNumber": "",
          "epfEmployerContribution": EPF_RESTRICT_TO_CEILING,
          "epfEmployeeContribution": "12% of PF Wage",
          "esiNumber": "",
          "esiEmployerContribution": 0,
          "esiEmployeeContribution": 0,
          "ptNumber": "",
          "epfApplicable": true,
          "esiApplicable": true,
          "edliApplicable": false,
          "epfAdminChargesApplicable": false,
          "epfContributionInCtc": false,
          "edliContributionInCtc": false,
          "epfAdminContributionInCtc": false,
          "laborWelfareFund": false,
          "esiContributionInCtc": false,
          "defaultTaxRegime" : IN_TAX_REGIME_OPTIONS.NEW_TAX_REGIME
        }
    }
    validationObj = {
        epefNumber: {
            errMsg: 'Please enter valid the EPF number',
            hasError: false,
            tooltip: `The EPF number should follow the pattern <br> ${EPF_NUMBER_MASK} where S-Alphabet 0-Number`,
            regex: EPF_REGEX_PATTERN
        },
        esiNumber: {
            errMsg: 'Please enter valid the ESI number',
            hasError: false,
            tooltip: `The ESI number should follow  the pattern <br> ${ESI_NUMBER_MASK} where 0-Number`,
            regex: ESI_REGEX_PATTERN
        },
        ptNumber: {
            errMsg: 'Please enter the PT number',
            hasError: false,
            tooltip: 'The ESI number should be number',
            regex: NUMBER_REGEX_PATTERN
        },
        epfEmployerContribution: {
            errMsg: 'Select a valid employer contribution rate',
            hasError: false,
        },
        epfEmployeeContribution: {
            errMsg: 'Select a valid employee contribution rate',
            hasError: false,
        }

    }
    constructor(props) {
        super(props);
        this.state = this.taxDeatils;
        this.getTaxDetail();
        this.getESITax();
        RouteManager.setPresenter(this)
    }
    getTaxDetail(){
        INTaxService.getTaxDetail()
        .then(res=>{
            this.metaData = res;
            let dataObj = {
                ...this.state,
                compliance: res && res["compliance"]
                  ? res["compliance"]
                  : this.taxDeatils.compliance,
              }
              if(Utility.isEmpty(dataObj.compliance.epfEmployeeContribution)) {
                  dataObj['compliance'] = {
                      ...dataObj['compliance'],
                      epfEmployeeContribution: "12% of PF Wage"
                  }
              }
              ['epfEmployerContribution', 'epfEmployeeContribution'].forEach(key => {
                  if (dataObj.compliance[key] === EPF_RESTRICT_TO_CEILING_LEGACY) {
                      dataObj['compliance'] = {
                          ...dataObj['compliance'],
                          [key]: EPF_RESTRICT_TO_CEILING
                      }
                  }
              });
            this.setState(dataObj);
        })
    }
    getESITax(){
        INTaxService.getTaxESI()
        .then(res=>{
            this.taxDeatils['ESI_rate'] = res;
            this.updateState();
        })
    }
    updateState(){
        this.setState({
            ...this.state
        })
    }
    isValidate(){
        let keys = Object.keys(this.taxDeatils.compliance);
        let compliance = this.state.compliance;
        let isValid = true;
        keys.forEach(field=>{
            switch(field){
                case "epefNumber":
                    if(compliance.epfApplicable &&(compliance[field] == "" || this.validationObj[field].hasError) ) {
                        this.validationObj[field].hasError = true;
                        isValid = false;
                        return false;
                    }
                    break;
                case "epfEmployerContribution":
                    if(compliance.epfApplicable &&compliance[field] == ""){
                        this.validationObj[field].hasError = true;
                        this.updateState();
                        isValid = false;
                        return false;
                    }
                    break;
                case "epfEmployeeContribution":
                    if (compliance.epfApplicable && compliance[field] == "") {
                        this.validationObj[field].hasError = true;
                        this.updateState();
                        isValid = false;
                        return false;
                    }
                    break;
                case "esiNumber":
                    if(compliance.esiApplicable &&(compliance[field] == "" || this.validationObj[field].hasError) ) {
                        this.validationObj[field].hasError = true;
                        isValid = false;
                        return false;
                    }
                    break;
                case "ptNumber":
                    if(this.checkRequiredConfiguration(COLUMN_CODES.IS_PT_APPLICABLE) && (compliance[field] == "" || this.validationObj[field].hasError) ) {
                        this.validationObj[field].hasError = true;
                        isValid = false;
                        return false;
                    }
                    break;

            }
        })
        return isValid;

    }
    save() {
        if(!this.isValidate()) {
            this.updateState()
            return;
        }

        let obj = {
            compliance: this.state.compliance,
            id: this.metaData?.['id'],
            countryCode: 'IN'
        }
        if (!obj.compliance.defaultTaxRegime) {
            obj.compliance.defaultTaxRegime = IN_TAX_REGIME_OPTIONS.NEW_TAX_REGIME
        }
        if(this.metaData?.['id']) {
            INTaxService.updateTaxDetail(obj)
            .then(res=>{
                showToast(
                    "Tax details updated successfuly",
                    TOAST_TYPE.SUCCESS
                );
                ProfileSetupService.updateStateOfProfileStage(PROFILE_STAGES_CONSTANT.TAX_DETAILS)
                .then(res=>{

                    TenantManager.setProfileData(res['profileStages']);


                })
                this.navigateTo()
            },
            error=>{
                showToast(
                    "Internal server error.",
                    TOAST_TYPE.FAILURE
                );
            })
        } else {
            INTaxService.saveTaxDetail(obj)
            .then(res=>{
                showToast(
                    "Tax details saved successfuly",
                    TOAST_TYPE.SUCCESS
                );
                ProfileSetupService.updateStateOfProfileStage(PROFILE_STAGES_CONSTANT.TAX_DETAILS)
                .then(res=>{
                    TenantManager.setProfileData(res['profileStages']);
                    this.navigateTo()
                },
                error=>{
                    this.navigateTo()
                })

            },
            error=>{
                showToast(
                    "Internal server error.",
                    TOAST_TYPE.FAILURE
                );
            })
        }
    }
    navigateTo() {
        RouteManager.navigateToPage('')
    }
    getHeader(){
        return (
            <div className="parent-width d-flex justify-content-between">
                    <DKLabel
                        text="Tax Details"
                        className=" fs-r text-align-left fw-m fs-l"
                    />
                    <div className="d-flex">
                    <DKButton
                        title="Cancel"
                        className="border-radius-m bg-gray1 border-m mr-m"
                        onClick={() => {
                            this.navigateTo()
                        }}
                    />
                    {PermissionUtils.hasAccess(MODULE.COMPANY_SETTINGS, [ACTION.EDIT]) && <DKButton
                        title="Save"
                        className="bg-app text-white"
                        onClick={() => {
                            this.save()
                        }}
                    />}
                    </div>
                </div>
        )
    }
    getError(obj){
        return (
            <>
            {obj.hasError && (
                    <DKLabel
                      className="pl-s fs-s unselectable text-red pt-s"
                      style={{
                        whiteSpace: "nowrap",
                      }}
                      text={
                        obj.errMsg
                        //   getCapitalized(this.props.title)
                        //   (this.state.required === true ? " *" : "")
                      }
                    />
                  )}
            </>
        )
    }
    getInfo(msg) {
        return (
            <>
                <span data-tip={msg} style={{marginLeft: -32,
                    marginTop: 37,
                    zIndex: 1
                    }}>
                <DKIcon style={{height: 20}}
                    src={ic_info_warning}
                />
                </span>
                <ReactTooltip type="dark" place="right" html={true} effect='solid' />
            </>
        )
    }
    onchange(value, field) {
        this.state.compliance[field] = value;
        const regexPAN = new RegExp(this.validationObj[field].regex);
        switch(field) {
            case "ptNumber":
                this.validationObj[field].hasError = !regexPAN.test(value) && this.checkRequiredConfiguration(COLUMN_CODES.IS_PT_APPLICABLE);
                break;
            default:
                this.validationObj[field].hasError = !regexPAN.test(value);
        }
        this.updateState();
    }

    checkRequiredConfiguration(fieldName) {
        const tenantConfiguration = TenantManager.getPeopleTenantData();
        const tenantDetails = tenantConfiguration.tenant;
        const addressDetails = tenantDetails?.address;
        let required = true;
        switch (fieldName) {
            case COLUMN_CODES.IS_PT_APPLICABLE:
                const index = IN_STATES_WITH_CONFIGURATION.findIndex(
                  (x) => x.value === addressDetails?.state
                );
                if(index != -1) {
                    const stateConfiguration = IN_STATES_WITH_CONFIGURATION[index];
                    required = stateConfiguration.isPTApplicable;
                }
        }
        return required;
    }

    getPageContent(){
        return(
            <div style={{
                pointerEvents: PermissionUtils.hasAccess(MODULE.COMPANY_SETTINGS, [ACTION.EDIT]) ? "initial":"none",
                opacity: PermissionUtils.hasAccess(MODULE.COMPANY_SETTINGS, [ACTION.EDIT]) ? "1":"0.9"
              }}>
            <div className="bg-white border-radius-s shadow-s mt-l">
                <DKLabel
                    text="EPF"
                    className=" fs-r text-align-left fw-m fs-l p-xl"
                />
                <DKLine className="bg-gray3"/>
                <div className="p-xl">
                <div className="d-flex align-items-center  mb-l">
                    <Toggle
                        className="border-n"
                        isOn={(this.state.compliance.epfApplicable) ? this.state.compliance.epfApplicable : false}
                        onChange={() => {
                            this.state.compliance.epfApplicable = !this.state.compliance.epfApplicable
                            if(!this.state.compliance.epfApplicable) {
                                this.state.compliance.epfAdminChargesApplicable = false
                                this.state.compliance.edliApplicable = false;
                                this.state.compliance.epfContributionInCtc = false;

                            }
                            if(!this.state.compliance.epfContributionInCtc) {

                                this.state.compliance.edliContributionInCtc = false;
                                this.state.compliance.epfAdminContributionInCtc = false
                            }
                            this.updateState()
                        }}
                    />
                    <DKLabel className="ml-s" text={"EPF Applicable"} />
                </div>

                        {this.state.compliance.epfApplicable && <div className="d-flex">
                            <div className="pr-l" style={{
                                width: "40%"
                            }}>
                                <div className='d-flex'>
                                    <DKInput
                                        title="EPF Number"
                                        value={this.state.compliance.epefNumber}
                                        className=""
                                        type={INPUT_TYPE.TEXT}
                                        showError={false}
                                        direction={INPUT_VIEW_DIRECTION.VERTICAL}
                                        readOnly={!PermissionUtils.hasAccess(MODULE.COMPANY_SETTINGS,[ACTION.EDIT])}
                                        required={true}
                                        // invalid={this.validationObj.epefNumber.hasError}
                                        canValidate={false}
                                        errorMessage={'EPF Number is required'}
                                        tooltip={{
                                            "content": this.validationObj.epefNumber.tooltip,
                                            "className": "warning-tooltip-prop"
                                        }}
                                        onChange={value => {
                                            this.onchange(value, 'epefNumber');
                                        }
                                        }
                                    />
                                    {/* {this.getInfo(this.validationObj.epefNumber.tooltip)} */}

                                </div>
                                {this.getError(this.validationObj.epefNumber)}
                            </div>
                            <div className="pl-l" style={{
                                width: "40%"
                            }}>
                                <DKInput
                                    title="Employer Contribution Rate"
                                    value={this.state.compliance.epfEmployerContribution}
                                    formatter={(obj) => {
                                        /** How to render a selected option in case of object **/
                                        return obj;
                                    }}
                                    className=""
                                    type={INPUT_TYPE.DROPDOWN}
                                    showError={true}
                                    direction={INPUT_VIEW_DIRECTION.VERTICAL}
                                    readOnly={!PermissionUtils.hasAccess(MODULE.COMPANY_SETTINGS,[ACTION.EDIT])}
                                    required={true}
                                    canValidate={false}
                                    options={EPF_EMPLOYER_CONTRIBUTION}
                                    onChange={value => {
                                        if (!Utility.isEmpty(value)) {
                                            this.state.compliance.epfEmployerContribution = value;
                                            this.validationObj.epfEmployerContribution.hasError = false;
                                        } else {
                                            this.state.compliance.epfEmployerContribution = '';
                                            this.validationObj.epfEmployerContribution.hasError = true;
                                        }

                                        this.updateState()
                                    }
                                    }
                                    dropdownConfig={{
                                        className: "",
                                        style: {},
                                        allowSearch:
                                            EPF_EMPLOYER_CONTRIBUTION && EPF_EMPLOYER_CONTRIBUTION.length > 6
                                                ? true
                                                : false,
                                        searchableKey: "name",
                                        data: EPF_EMPLOYER_CONTRIBUTION,
                                        renderer: (index, obj) => {
                                            /** How to render value in Dropdown in case of object **/
                                            return <DKLabel text={`${obj}`} />;
                                        },
                                        onSelect: (index, obj) => {
                                            // onValueChange(obj, "Quarter");
                                        },
                                    }}
                                />
                                {
                                    this.getError(this.validationObj.epfEmployerContribution)
                                }
                            </div>

                        </div>}
                        {this.state.compliance.epfApplicable && <div className="d-flex mt-l">

                            {this.state.compliance.epfApplicable && <div className="pr-l" style={{
                                width: "40%"
                            }}>
                                <DKInput
                                    title="Employee Contribution Rate"
                                    value={this.state.compliance.epfEmployeeContribution}
                                    formatter={(obj) => {
                                        /** How to render a selected option in case of object **/
                                        return obj;
                                    }}
                                    className=""
                                    type={INPUT_TYPE.DROPDOWN}
                                    showError={true}
                                    direction={INPUT_VIEW_DIRECTION.VERTICAL}
                                    readOnly={!PermissionUtils.hasAccess(MODULE.COMPANY_SETTINGS,[ACTION.EDIT])}
                                    required={true}
                                    canValidate={false}
                                    options={EPF_EMPLOYER_CONTRIBUTION}
                                    onChange={value => {
                                        if (!Utility.isEmpty(value)) {
                                            this.state.compliance.epfEmployeeContribution = value;
                                            this.validationObj.epfEmployeeContribution.hasError = false;
                                        } else {
                                            this.state.compliance.epfEmployeeContribution = '';
                                            this.validationObj.epfEmployeeContribution.hasError = true;
                                        }

                                        this.updateState()
                                    }
                                    }
                                    dropdownConfig={{
                                        className: "",
                                        style: {},
                                        allowSearch:
                                            EPF_EMPLOYER_CONTRIBUTION && EPF_EMPLOYER_CONTRIBUTION.length > 6
                                                ? true
                                                : false,
                                        searchableKey: "name",
                                        data: EPF_EMPLOYER_CONTRIBUTION,
                                        renderer: (index, obj) => {
                                            /** How to render value in Dropdown in case of object **/
                                            return <DKLabel text={`${obj}`} />;
                                        },
                                        onSelect: (index, obj) => {
                                            // onValueChange(obj, "Quarter");
                                        },
                                    }}
                                />
                                {
                                    this.getError(this.validationObj.epfEmployeeContribution)
                                }
                            </div>}

                            <div className="pl-l" style={{
                                width: "40%"
                            }}>
                                <div
                                    className=" d-flex pt-s align-items-center parent-height cursor-hand mb-l"
                                    onClick={() => {
                                        this.state.compliance.edliApplicable = !this.state.compliance.edliApplicable;
                                        this.updateState()
                                    }}

                                >
                                    <DKCheckMark isSelected={this.state.compliance.edliApplicable} color="bg-app" /><DKLabel className="ml-s" text={"EDLI"} />
                                </div>
                            </div>

                        </div>}
                        {this.state.compliance.epfApplicable && <div className="d-flex">
                            <div className="pr-l" style={{
                                width: "40%"
                            }}>
                                <div
                                    className=" d-flex pt-s align-items-center parent-height cursor-hand mb-l"
                                    onClick={() => {
                                        this.state.compliance.epfAdminChargesApplicable = !this.state.compliance.epfAdminChargesApplicable;
                                        this.updateState()
                                    }}
                                >
                                    <DKCheckMark isSelected={this.state.compliance.epfAdminChargesApplicable} color="bg-app" /><DKLabel className="ml-s" text={"EPF Admin Charges"} />
                                </div>
                            </div>
                        </div>}

                        {false && <div className="d-flex">
                            {/* this.state.compliance.epfApplicable */}
                            <div className="pr-l" style={{
                                width: "40%"
                            }}>
                                <div
                                    className=" d-flex pt-s align-items-center parent-height cursor-hand mb-l"
                                    onClick={() => {
                                        this.state.compliance.epfContributionInCtc = !this.state.compliance.epfContributionInCtc;
                                        this.updateState()
                                    }}

                                >
                                    <DKCheckMark isSelected={this.state.compliance.epfContributionInCtc} color="bg-app" /><DKLabel className="ml-s" text={"EPF Contribution In CTC"} />
                                </div>
                            </div>
                            {this.state.compliance.epfContributionInCtc && <div className="pl-l" style={{
                                width: "40%"
                            }}>
                                <div
                                    className=" d-flex pt-s align-items-center parent-height cursor-hand mb-l"
                                    onClick={() => {
                                        this.state.compliance.edliContributionInCtc = !this.state.compliance.edliContributionInCtc;
                                        this.updateState()
                                    }}

                                >
                                    <DKCheckMark isSelected={this.state.compliance.edliContributionInCtc} color="bg-app" /><DKLabel className="ml-s" text={"EDLI Contribution In CTC"} />
                                </div>
                            </div>}
                        </div>
                        }

                        {false && <div className="d-flex">
                            {/* this.state.compliance.epfContributionInCtc */}
                            <div className="pr-l" style={{
                                width: "40%"
                            }}>
                                <div
                                    className=" d-flex pt-s align-items-center parent-height cursor-hand mb-l"
                                    onClick={() => {
                                        this.state.compliance.epfAdminContributionInCtc = !this.state.compliance.epfAdminContributionInCtc;
                                        this.updateState()
                                    }}

                                >
                                    <DKCheckMark isSelected={this.state.compliance.epfAdminContributionInCtc} color="bg-app" /><DKLabel className="ml-s" text={"EPF Admin Contribution In CTC"} />
                                </div>
                            </div>
                        </div>
                        }

                    </div>
            </div>

            {/* ESI */}

            <div className="bg-white border-radius-s shadow-s mt-l">
                <DKLabel
                    text="ESI"
                    className=" fs-r text-align-left fw-m fs-l p-xl"
                />
                <DKLine className="bg-gray3"/>
                <div className="p-xl">
                <div className="d-flex align-items-center  mb-l">
                    <Toggle
                        className="border-n"
                        isOn={(this.state.compliance.esiApplicable) ? this.state.compliance.esiApplicable : false}
                        onChange={() => {
                            this.state.compliance.esiApplicable = !this.state.compliance.esiApplicable
                            if(!this.state.compliance.esiApplicable) {
                                this.state.compliance.esiContributionInCtc = false;
                            }
                            this.updateState()
                        }}
                    />
                    <DKLabel className="ml-s" text={"ESI Applicable"} />
                </div>

                    {this.state.compliance.esiApplicable && <div>
                    <div className="d-flex">
                        <div className="pr-l" style={{
                            width:"40%"
                        }}>
                            <div className="d-flex">
                        <DKInput
                        title="ESI Number"
                        value={this.state.compliance.esiNumber}
                        className=""
                        type={INPUT_TYPE.TEXT}
                        showError={false}
                        direction={INPUT_VIEW_DIRECTION.VERTICAL}
                        readOnly={!PermissionUtils.hasAccess(MODULE.COMPANY_SETTINGS,[ACTION.EDIT])}
                        required={true}
                        canValidate={false}
                        tooltip = {{
                            "content" : this.validationObj.esiNumber.tooltip,
                            "className" : "warning-tooltip-prop"
                        }}
                        onChange={ value =>{
                            this.onchange(value,'esiNumber');
                        }
                        }
                        />
                        </div>
                        {this.getError(this.validationObj.esiNumber)}

                        </div>

                        </div>

                        <div className="d-flex mt-xl">
                            <div className="pr-l" style={{
                                width:"40%"
                            }}>
                                <DKLabel
                                className="text-gray"
                                text={'Employer Contribution Rate'}
                                />
                                <DKLabel
                                className=" fw-m"
                                text={`${this.taxDeatils['ESI_rate'] ? this.taxDeatils['ESI_rate'].esiEmployerRate : ''}%`}
                                />
                            </div>
                            <div className="pl-l" style={{
                                width:"40%"
                            }}>
                            <DKLabel
                                className="text-gray"
                                text={'Employee Contribution Rate'}
                                />
                                <DKLabel
                                className=" fw-m"
                                text={`${this.taxDeatils['ESI_rate'] ? this.taxDeatils['ESI_rate'].esiEmployeeRate : ''}%`}
                                />
                            </div>

                        </div>

                        {false && <div className="d-flex">
                        {/* this.state.compliance.esiApplicable */}
                            <div className="pr-l" style={{
                                width: "40%"
                            }}>
                                <div
                                    className=" d-flex pt-s align-items-center parent-height cursor-hand mb-l"
                                    onClick={() => {
                                        this.state.compliance.esiContributionInCtc = !this.state.compliance.esiContributionInCtc;
                                        this.updateState()
                                    }}

                                >
                                    <DKCheckMark isSelected={this.state.compliance.esiContributionInCtc} color="bg-app" /><DKLabel className="ml-s" text={"ESI Contribution In CTC"} />
                                </div>
                            </div>
                            </div>
                            }

                    </div>}
                </div>
            </div>

            {/* Professional Tax */}

            <div className="bg-white border-radius-s shadow-s mt-l">
                <DKLabel
                    text="Professional Tax"
                    className=" fs-r text-align-left fw-m fs-l p-xl"
                />
                <DKLine className="bg-gray3"/>
                <div className="p-xl">


                    { <div>
                    <div className="d-flex">
                        <div className="pr-l" style={{
                            width:"40%"
                        }}>
                        <DKInput
                        title="PT Number"
                        value={this.state.compliance.ptNumber}
                        className=""
                        type={INPUT_TYPE.TEXT}
                        showError={false}
                        direction={INPUT_VIEW_DIRECTION.VERTICAL}
                        readOnly={!PermissionUtils.hasAccess(MODULE.COMPANY_SETTINGS,[ACTION.EDIT])}
                        required={this.checkRequiredConfiguration("isPTApplicable")}
                        canValidate={false}
                        onChange={ value =>{
                            this.onchange(value,'ptNumber');
                        }
                        }
                        />
                        {this.getError(this.validationObj.ptNumber)}
                        </div>

                        </div>
                    </div>}
                </div>
            </div>

            {/* ESI */}

            <div className="bg-white border-radius-s shadow-s mt-l mb-xl">
                <DKLabel
                    text="Labor Welfare Fund"
                    className=" fs-r text-align-left fw-m fs-l p-xl"
                />
                <DKLine className="bg-gray3"/>
                <div className="p-xl">
                <div className="d-flex align-items-center  mb-l">
                    <Toggle
                        className="border-n"
                        isOn={(this.state.compliance.laborWelfareFund) ? this.state.compliance.laborWelfareFund : false}
                        onChange={() => {
                            this.state.compliance.laborWelfareFund = !this.state.compliance.laborWelfareFund
                            this.updateState()
                        }}
                    />
                    <DKLabel className="ml-s" text={"Labor Welfare Fund"} />
                </div>
                </div>
                </div>

                <div className="bg-white border-radius-s shadow-s mt-l mb-xl">
                    <DKLabel
                        text="Default Tax Regime"
                        className=" fs-r text-align-left fw-m fs-l p-xl"
                    />
                    <DKLine className="bg-gray3" />
                    <div className="row p-xl">
                        <div className="row" style={{ width: "auto" }}>
                            <DKRadioButton
                                isSelected={
                                    (this.state.compliance.defaultTaxRegime === "")
                                    ? false
                                    : this.state.compliance.defaultTaxRegime === IN_TAX_REGIME_OPTIONS.OLD_TAX_REGIME}
                                color="bg-app"
                                onClick={() => {
                                    this.state.compliance.defaultTaxRegime = IN_TAX_REGIME_OPTIONS.OLD_TAX_REGIME
                                    this.updateState()
                                }}
                            />
                            <DKLabel className="ml-s mr-l" text="Old Tax Regime" />
                        </div>
                        <div className="row" style={{ width: "auto" }}>
                            <DKRadioButton
                                isSelected={
                                    (this.state.compliance.defaultTaxRegime === "" || 
                                    this.state.compliance.defaultTaxRegime === undefined)
                                    ? true
                                    : this.state.compliance.defaultTaxRegime === IN_TAX_REGIME_OPTIONS.NEW_TAX_REGIME}                                color="bg-app"
                                onClick={() => {
                                    this.state.compliance.defaultTaxRegime = IN_TAX_REGIME_OPTIONS.NEW_TAX_REGIME
                                    this.updateState()
                                }}
                            />
                            <DKLabel className="ml-s mr-l" text="New Tax Regime" />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
    render(){
        return (
            <>
            <div className="parent-width">
                {this.getHeader()}
                {this.getPageContent()}
            </div>
            </>
        )
    }
}
export default TaxDetails